module.exports = __webpack_public_path__ + "media/images/official/about_comipla_image3-7a82cdb86e4ab68767fd69628502ad9b.jpg";